// Note, this string must match the one from src/styles/variables.scss
// eslint-disable-next-line import/prefer-default-export
export const WEBEX_COMPONENTS_CLASS_PREFIX = 'wxc';
